import { render, staticRenderFns } from "./MainNavigationMiniCard.vue?vue&type=template&id=21471623&scoped=true&"
import script from "./MainNavigationMiniCard.vue?vue&type=script&lang=js&"
export * from "./MainNavigationMiniCard.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationMiniCard.vue?vue&type=style&index=0&id=21471623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21471623",
  null
  
)

export default component.exports